import React, { useEffect, useState } from 'react';
import { useSite } from '../../context/SiteContext';
import { adminListLeads } from '../../services/api';
import { Package, Wallet, Film, Inbox, FileText, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const Card = ({ icon: Icon, label, value, href }) => (
  <Link
    to={href}
    className="group block rounded-2xl border border-white/8 bg-white/[0.02] hover:bg-white/[0.04] hover:border-[#00e0c7]/30 p-6 transition-all"
  >
    <div className="flex items-center justify-between mb-4">
      <div className="w-11 h-11 rounded-xl bg-[#00e0c7]/10 border border-[#00e0c7]/20 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#00e0c7]" />
      </div>
      <TrendingUp className="w-4 h-4 text-white/20 group-hover:text-[#00e0c7] transition-colors" />
    </div>
    <div className="text-3xl font-display text-white font-light">{value}</div>
    <div className="text-[12px] uppercase tracking-widest text-white/40 mt-1">{label}</div>
  </Link>
);

const AdminDashboard = () => {
  const { services, pricing, works, content } = useSite();
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    adminListLeads().then(setLeads).catch(() => setLeads([]));
  }, []);

  const unreadLeads = leads.filter((l) => !l.read).length;

  return (
    <div>
      <div className="mb-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#00e0c7] mb-3">Panel Administrativo</div>
        <h1 className="font-display text-4xl text-white font-light">Dashboard</h1>
        <p className="text-white/50 mt-2 text-sm">Resumen general de tu plataforma.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card icon={Inbox} label="Leads sin leer" value={unreadLeads} href="/admin/leads" />
        <Card icon={Package} label="Servicios activos" value={services?.length || 0} href="/admin/services" />
        <Card icon={Wallet} label="Filas de tarifas" value={pricing?.length || 0} href="/admin/pricing" />
        <Card icon={Film} label="Trabajos / películas" value={works?.length || 0} href="/admin/works" />
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-white/8 bg-white/[0.02] p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-white font-medium">Acceso rápido</h3>
            <FileText className="w-4 h-4 text-white/30" />
          </div>
          <div className="space-y-2">
            <Link to="/admin/content" className="block p-3 rounded-lg hover:bg-white/5 text-white/70 hover:text-white text-sm border border-white/5 hover:border-white/10 transition-all">
              → Editar contenido del Hero, About, Contact
            </Link>
            <Link to="/admin/services" className="block p-3 rounded-lg hover:bg-white/5 text-white/70 hover:text-white text-sm border border-white/5 hover:border-white/10 transition-all">
              → Gestionar servicios
            </Link>
            <Link to="/admin/leads" className="block p-3 rounded-lg hover:bg-white/5 text-white/70 hover:text-white text-sm border border-white/5 hover:border-white/10 transition-all">
              → Revisar leads recibidos
            </Link>
          </div>
        </div>

        <div className="rounded-2xl border border-white/8 bg-white/[0.02] p-6">
          <h3 className="text-white font-medium mb-4">Últimos leads</h3>
          {leads.slice(0, 4).length === 0 ? (
            <p className="text-white/40 text-sm">Aún no hay leads.</p>
          ) : (
            <ul className="space-y-2">
              {leads.slice(0, 4).map((l) => (
                <li key={l.id} className="flex items-center justify-between p-3 rounded-lg border border-white/5 bg-white/[0.02]">
                  <div>
                    <div className="text-white text-sm">{l.name}</div>
                    <div className="text-white/40 text-[11px]">{l.company}</div>
                  </div>
                  {!l.read && (
                    <span className="px-2 py-0.5 rounded-full bg-[#00e0c7]/10 border border-[#00e0c7]/20 text-[10px] text-[#00e0c7] uppercase tracking-widest">
                      Nuevo
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
